export const GroupDetails = () => import("./GroupDetails.vue");
export const Groups = () => import("./Groups.vue");
